import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { formatCurrency } from '../../../lib/currency';
import { prettyLocalDate } from '../../../lib/time';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    marginTop: '2rem',
  }
});

const MatchingFeesTable = ({matchingFees}) => {
  const classes = useStyles();

  const tableHeader = () => (
    <TableRow>
      <TableCell>Due Date</TableCell>
      <TableCell>Description</TableCell>
      <TableCell align="right">Amount Incl GST</TableCell>
    </TableRow>
  );

  const tableRow = (item) => (
    <TableRow key={item.id}>
      <TableCell>
        {prettyLocalDate(item.due_date)}
      </TableCell>
      <TableCell>
        {item.description}
      </TableCell>
      <TableCell align="right">
        {formatCurrency(item.amount.incl)}
      </TableCell>
    </TableRow>
  );

  const totalRow = (matchingFees) => (
    <TableRow>
      <TableCell>
      </TableCell>
      <TableCell>
        Total for next payment
      </TableCell>
      <TableCell align="right">
        {formatCurrency(matchingFees.total.incl)}
      </TableCell>
    </TableRow>
  );

  return (
    <div className={classes.container}>
      <Typography variant="h6">Next Matching Payment</Typography>
      <Table size="small">
        <TableHead>
          {tableHeader()}
        </TableHead>
        <TableBody>
          {matchingFees.items.map(item => tableRow(item))}
          {totalRow(matchingFees)}
        </TableBody>
      </Table>
    </div>
  );
};

MatchingFeesTable.propTypes = {
  matchingFees: PropTypes.object.isRequired,
};

export default MatchingFeesTable;
